import styled from 'styled-components';

export const Body = styled.div`
  overflow-x: hidden;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  padding-bottom: 80px;
`;

export const BackButton = styled.button`
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 10;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #333;
  font-size: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
`;

export const ArrowContainer = styled.button<{ right?: string; left?: string }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: none;
  padding: 10px;
  margin: 0;
  ${({ right }) => (right ? 'right: 10px;' : 'left: 10px;')}
  z-index: 1;
  cursor: pointer;

  img {
    width: 30px;
    height: 30px;
  }
`;

export const TextContainer = styled.div`
  flex: 1;
  padding: 0;
  text-align: left;
`;

export const TitleText = styled.div`
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
  text-align: left;
`;

export const Number = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  text-align: left;
`;

export const Time = styled.div`
  font-size: 14px;
  color: #999;
  text-align: left;
  position: relative;
`;

export const TimeToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  user-select: none;

  &:hover {
    color: #666;
  }
`;

export const TimeDropdown = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 4px;
  background: white;
  border: 1px solid #E5E5E5;
  border-radius: 8px;
  padding: 8px 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  min-width: 150px;

  div {
    padding: 4px 0;
    color: #333;
  }
`;

export const All = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px;
  gap: 15px;
`;

export const StarRateWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 0px;

  .star_icon {
    display: inline-flex;
    margin-right: 2px;
  }
`;

export const ReviewButton = styled.div`
  margin-top: 28px;

  .button1 {
    border: none;
    background-color: transparent;
    color: #15a962ff;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    padding: 0;
  }
`;

export const StarText = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #FFBE55;
  margin-left: 5px;
`;

export const ReviewWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const ImageSlider = styled.div`
  position: relative;
  width: 100%;
  max-width: 480px;

  .img {
    width: 100%;
    height: 300px;
    object-fit: cover;
  }

  .slide-container {
    width: 100%;
  }
`;

export const ReviewSlider = styled.div`
  margin-bottom: 17px;
  padding: 0px 10px 0px 5px;
  overflow: visible;

  .review-slide {
    padding: 15px;
    border: 1px solid #E5E5E5;
    box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.15);
    border-radius: 20px;
    background: white;
  }

  .slick-track {
    display: flex;
    gap: 10px;
    overflow: visible;
  }

  .slick-slide {
    width: 340px !important;
    overflow: visible;
  }

  .slick-list {
    overflow: visible;
  }
`;

export const ReviewDate = styled.div`
  font-size: 11px;
  color: #B1B1B1;
`;

export const ReviewInfo = styled.div`
  margin-left: 8px;
  flex: 1;
  text-align: left;

  .nickName {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    text-align: left;
  }
`;

export const StarRateWrap2 = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;

  .star_icon {
    display: inline-flex;
    margin-right: 1px;
  }
`;

export const ReviewContainer = styled.div`
  margin: 0 5px;
`;

export const ReviewDetail = styled.div`
  font-size: 14px;
  color: #5f5e5eff;
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  .img12 {
    width: 36px;
    height: 36px;
    border-radius: 18px;
    object-fit: cover;
  }
`;

export const MapInfo = styled.div`
  margin-top: 5px;
`;

export const DetailTitle = styled.div`
  font-size: 13px;
  color: #999;
  margin-bottom: 8px;
  padding: 0 20px;
  text-align: left;
`;

export const DetailContent = styled.div`
  font-size: 15px;
  color: #333;
  margin-bottom: 15px;
  line-height: 1.5;
  padding: 0 20px;
  text-align: left;
`;

export const Map = styled.div`
  margin: 15px 0 0 0;
  padding: 0;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;
`;

export const LocationData = styled.div`
  padding: 0;
`;

export const DataContainer = styled.div`
  margin-top: 30px;
`;

export const Button1 = styled.div`
  flex: 1;
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  color: #1FBC70;
  border: 2px solid #1FBC70;
  border-radius: 25px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: white;

  &:hover {
    background: #f0fdf7;
  }
`;

export const Button2 = styled.div`
  flex: 1;
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  color: #FFFFFF;
  background-color: #1FBC70;
  border-radius: 25px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 2px solid #1FBC70;

  &:hover {
    background-color: #18a860;
  }
`;

export const ButtonContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  max-width: 480px;
  width: 100%;
  display: flex;
  gap: 10px;
  padding: 15px 20px;
  background: white;
  border-top: 1px solid #E5E5E5;
  z-index: 10;
`;

export const LiveTalkSection = styled.div<{ hasReservationButtons?: boolean }>`
  margin-top: 30px;
  padding: 0 20px;
  margin-bottom: ${({ hasReservationButtons }) => hasReservationButtons ? '20px' : '0'};
`;

export const LiveTalkHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

export const LiveTalkTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #333;
`;

export const ViewAllButton = styled.button`
  border: none;
  background: none;
  color: #1FBC70;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
`;

export const LiveTalkList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const LiveTalkItem = styled.div`
  padding: 12px 15px;
  background: #F8F9FA;
  border-radius: 12px;
  cursor: pointer;

  &:hover {
    background: #F0F1F3;
  }
`;

export const LiveTalkItemHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const LiveTalkProfileImage = styled.img`
  width: 28px;
  height: 28px;
  border-radius: 14px;
  object-fit: cover;
  margin-right: 8px;
`;

export const LiveTalkUserInfo = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const LiveTalkUsername = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #333;
`;

export const LiveTalkTime = styled.span`
  font-size: 11px;
  color: #999;
`;

export const LiveTalkContent = styled.div`
  font-size: 14px;
  color: #555;
  line-height: 1.4;
  margin-left: 0;
  white-space: pre-wrap;
  text-align: left;
`;

export const LiveTalkEmpty = styled.div`
  padding: 40px 20px;
  text-align: center;
  color: #999;
  font-size: 14px;
`;
